export default "<div class=\"lds-ring\" [ngClass]=\"dark ? 'grey' : 'white'\">\n  <div></div>\n  <div></div>\n  <div></div>\n  <div></div>\n</div>\n";